import { combineReducers } from '@reduxjs/toolkit'

import { reducer as toastReducer } from '../services/Toast/store/toast.slice'
import { reducer as loadingReducer } from '../services/Loading/store/loading.slice'

import { reducer as accountReducer } from '@/modules/AccountPage/store/accont.slice'
import { reducer as resellersReducer } from '@/modules/AccountPage/store/resellers.slice'
import { reducer as licensesReducer } from '@/modules/LicensesPage/store/licenses.slice'
import { reducer as licenseVersionsReducer } from '../services/LicenseVersions/store/license-versions.slice'
import { reducer as versionReducer } from '../services/Maintenance/store/version.slice'

const rootReducer = combineReducers({
  toastReducer,
  loadingReducer,
  accountReducer,
  licensesReducer,
  resellersReducer,
  licenseVersionsReducer,
  versionReducer,
})

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer
